
import React, { Component, useEffect, useState } from 'react';
import { Redirect, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withStyles, useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Navigator from '../navigator';
import AppBar from './appbar';
import OrderGrid from './order-grid';
import Sidebar from './sidebar';
import SignalR from '../signalr';
import KeyHandler from '../key-handler';
import Sound from '../sound';
import {
  OrderDialog,
  DeliveryDialog,
  RouteDialog,
  ArticleListDialog,
  SettingsDialog,
  NewOrderDialog,
  DeliveryTimeDialog,
  ProductDialog,
  ReportDialog
} from '../components';

import useMediaQuery from '@material-ui/core/useMediaQuery';


function Main(props) {
  const { classes, selectedFilterMode, windowsize, localSettings, location } = props;
  const theme = useTheme();
  const [isOffline, setIsOffline] = useState(false);
  const [sideBarExpanded, setSideBarExpanded] = useState(false);
  const isXsDevice = useMediaQuery(theme.breakpoints.down('xs'));

  const isInApp = (location && location.search && location.search.indexOf('in_app') > -1);

  useEffect(() => {
    props.loadUiOptions();
    props.loadOrders();
    props.initPrinter();

    if (localSettings.showProductionPlaceFilter) {
      props.loadProductionPlaces();
    }
  }, []);

  const updateStatus = (offline) => {
    setIsOffline(offline);
  };

  window.addEventListener('online', () => updateStatus(false));
  window.addEventListener('offline', () => updateStatus(true));

  if (!props.loggedIn) {
    return <Redirect to="/login" />;
  }

  const showTickets = localSettings.showTickets != false;

  return (
    <div className="body">
      <AppBar isInApp={isInApp} isOffline={isOffline} />
      <Grid
        container
        direction="row"
        classes={{ root: 'main' }}
      >
        {showTickets ? (
          <Grid
            item
            container
            xs={12}
            lg={localSettings.showSidebar ? (sideBarExpanded ? 1 : 9) : 12}
            xl={localSettings.showSidebar ? (sideBarExpanded ? 1 : 10) : 12}
            className={classes.ordersContainer}
          >
            <OrderGrid isInApp={isInApp} />
          </Grid>
          ) : null        
        }


        {localSettings.showSidebar ?
          <Hidden mdDown={!!showTickets}>
            <Grid item xs={showTickets ? undefined : 12}
             lg={sideBarExpanded ? 11 : (showTickets ? 3 : 12)} 
             xl={(sideBarExpanded ? 11 : (showTickets ? 2 : 12))}>
              <Sidebar isExpanded={sideBarExpanded} toggleSidebar={() => {
                 setSideBarExpanded(!sideBarExpanded)
                 console.log('test');
              }} />
            </Grid>
          </Hidden>
          : null}
      </Grid>

      <Navigator />
      <SignalR />
      <Sound />
      <KeyHandler />
      <OrderDialog />
      <DeliveryDialog />
      <DeliveryTimeDialog />
      <RouteDialog />
      <ArticleListDialog />
      <SettingsDialog />
      <ReportDialog />
      <NewOrderDialog />
      <ProductDialog />
    </div >
  );
}


Main.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  selectedFilterMode: PropTypes.string.isRequired,
  loadOrders: PropTypes.func.isRequired,
  loadUiOptions: PropTypes.func.isRequired,
  initPrinter: PropTypes.func.isRequired,
  loadProductionPlaces: PropTypes.func.isRequired,
  localSettings: PropTypes.object.isRequired,
};

Main.defaultProps = {
  loggedIn: false,
};

const styles = theme => ({
  root: {
    // height: '100vh', overflow: 'hidden',
    // position: "fixed",
    backgroundColor: theme.backgroundcolor,
  },
  ordersContainer: {
    overflowY: 'auto',
    overflowX: 'hidden',
    // height: `100vh`,
  },
});

export default withStyles(styles)(Main);
